export default "__VITE_ASSET__e1ee0a4d__"